'use client'

import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import { RiMoonLine } from 'react-icons/ri'

// The dark mode control (2026-11-01): a labelled switch, so it reads as a
// setting rather than an unexplained icon. The phone menu's full-width row
// by default; `compact` is the desktop masthead's utility line (header B).
export default function ThemeSwitch({ compact = false }) {
  const { resolvedTheme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)
  // next-themes only knows the theme in the browser.
  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => setMounted(true), [])

  const dark = mounted && resolvedTheme === 'dark'
  if (compact)
    return (
      <button
        type="button"
        role="switch"
        aria-checked={dark}
        onClick={() => setTheme(dark ? 'light' : 'dark')}
        className="inline-flex min-h-8 items-center gap-1.5 font-sans text-xs text-muted-foreground transition-colors hover:text-foreground"
      >
        <span
          aria-hidden="true"
          className={`relative inline-block h-4 w-7 rounded-full border border-foreground transition-colors ${
            dark ? 'bg-foreground' : 'bg-card'
          }`}
        >
          <span
            className={`absolute top-[2px] h-2.5 w-2.5 rounded-full transition-all ${
              dark ? 'left-[13px] bg-background' : 'left-[2px] bg-foreground'
            }`}
          />
        </span>
        Dark mode
      </button>
    )
  return (
    <button
      type="button"
      role="switch"
      aria-checked={dark}
      onClick={() => setTheme(dark ? 'light' : 'dark')}
      className="flex min-h-12 w-full items-center justify-between gap-3 font-sans text-[15px] text-foreground"
    >
      <span className="inline-flex items-center gap-3">
        <RiMoonLine className="h-5 w-5" aria-hidden="true" />
        Dark mode
      </span>
      <span
        aria-hidden="true"
        className={`relative inline-block h-6 w-10 rounded-full border border-foreground transition-colors ${
          dark ? 'bg-foreground' : 'bg-transparent'
        }`}
      >
        <span
          className={`absolute top-1/2 h-4 w-4 -translate-y-1/2 rounded-full transition-all ${
            dark ? 'left-[19px] bg-background' : 'left-[3px] bg-foreground'
          }`}
        />
      </span>
    </button>
  )
}
